function renderNumOfLenses(totalQuantity, numberOfEyes) {
  return (numberOfEyes > 1)
    ? `${totalQuantity} ${totalQuantity > 1 ? 'pairs' : 'pair'}`
    : `${totalQuantity} ${totalQuantity > 1 ? 'lenses' : 'lens'}`;
}

export default ({ boxSize, quantity, numberOfEyes }, solution) => {
  const numOfBoxes = quantity * numberOfEyes;
  const boxSizeString = `${renderNumOfLenses(boxSize * quantity, numberOfEyes)} (${numOfBoxes} box${numOfBoxes > 1 ? 'es' : ''})`;
  return `${boxSizeString} ${solution ? ' with solution' : ''}`;
};
